<mat-card style="border-color: #5775a8;">

  <mat-card-header style="background-color: #5775a8;">
    <div class="flex flex-row rounded-lg w-full">
      <div class="flex flex-col w-full">
        <h4 cdkDrag cdkDragRootElement=".cdk-overlay-pane" cdkDragHandle style="color:white;">Edit Follow up Site Visit
        </h4>
      </div>
    </div>
  </mat-card-header>

  <mat-card-content>
    <form [formGroup]="form">
      <div class="flex flex-col">
        <mat-form-field class="container">
          <mat-label>Follow up Visit Date</mat-label>
          <input matInput [matDatepicker]="followupDate" formControlName="followupDate">
          <mat-datepicker-toggle matSuffix [for]="followupDate"></mat-datepicker-toggle>
          <mat-datepicker #followupDate></mat-datepicker>
          <mat-error *ngIf="form.get('followupDate').invalid">
            Invalid Date.
          </mat-error>
        </mat-form-field>
        <div>
          <small class="text-muted"><br />Date must be within 30 days of the required remediation Date:
            <strong class="text-danger">{{siteVisit.requiredImplementationDate}}</strong></small>

        </div>
        <br />
        <div class="flex flex-col w-full" style="align-items: baseline;">
          <span>Was the site visit conducted?</span>
          <mat-radio-group formControlName="followupConducted">
            <mat-radio-button color="primary" class="p-x-8" value='1'
              (change)="siteVisitUpdate('1')">Yes</mat-radio-button>
            <mat-radio-button color="primary" class="p-l-8" value='0'
              (change)="siteVisitUpdate('0')">No</mat-radio-button>
          </mat-radio-group>
        </div>

        <div class="flex flex-col">
          <span *ngIf="followupFlag">Follow-up Visit Result</span>
          <span *ngIf="!followupFlag">Reason not conducted</span>
          <mat-radio-group formControlName="remediationResult" (change)="radioSelected($event.value)">
            <mat-radio-button *ngIf="followupFlag" color="primary" class="p-x-8" value='1'>
              The business completed the remediation plan successfully (complaint resolved).
            </mat-radio-button>
            <mat-radio-button *ngIf="followupFlag" color="primary" class="p-l-8" value='2'>
              The business did NOT complete the remediation plan (forward this complaint to OHA).
            </mat-radio-button>
            <mat-radio-button *ngIf="followupFlag" color="primary" class="p-l-8" value='3'>
              The business completed the remediation, and another violation was observed (forward this complaint to
              OHA).
            </mat-radio-button>
            <mat-radio-button *ngIf="followupFlag" color="primary" class="p-x-8" value='4'>
              The business did NOT complete the remediation plan, and additional violations were observed (forward this
              complaint to OHA).
            </mat-radio-button>
            <mat-radio-button *ngIf="!followupFlag" color="primary" class="p-l-8" value='1'>
              Follow-up visit denied (forward to OHA)
            </mat-radio-button>
            <mat-radio-button *ngIf="!followupFlag" color="primary" class="p-l-8" value='2'>
              Other (explain in comments)
            </mat-radio-button>
          </mat-radio-group>
          <span *ngIf="warningFlag" class="text-danger">
            <br />
            <span style="color:red;">
              You have chosen a Follow-up Visit Result that requires you to forward this Complaint to OHA
            </span>
          </span>
        </div>

        <!-- <div *ngIf="followupFlag" class="flex flex-col">
          <span>Reason not conducted</span>
          <mat-radio-group formControlName="violationFound">
            <mat-radio-button color="primary" class="p-x-8" value='1'>Yes</mat-radio-button>
            <mat-radio-button color="primary" class="p-l-8" value='0'>No &mdash; Complaint Resolved</mat-radio-button>
          </mat-radio-group>
        </div> -->
        <div class="flex clex-col w-full">
          <mat-form-field class="w-full">
            <mat-label>Site Visit Notes</mat-label>
            <textarea matInput cdkTextareaAutosize formControlName="comments" cdkAutosizeMinRows="6"></textarea>
          </mat-form-field>
        </div>

        <div class="flex flex-row w-full">
          <div style="padding-right: 20px;">
            <button mat-raised-button (click)="save()" style="padding-right: 20px; background: #7ABDF3;">
              Save
            </button>
          </div>

          <div style="padding-right: 20px;">
            <button mat-raised-button (click)="return()" style="padding-right: 20px;">
              Return
            </button>
          </div>
        </div>

      </div>

    </form>

  </mat-card-content>

</mat-card>